import { createStyles } from "antd-style";
const useStyles = createStyles(({ token }, props) => ({
  selectCompanyBg: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#b7c9d9",
    backgroundImage: `url("${props.backgroundImage}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    width: "80vw",
    height: "72px",
    background: "#FFFFFF",
    marginTop: "40px",
    marginBottom: "16px",
    borderRadius: token.borderRadius
  },
  headerLeft: {
    height: "72px",
    display: "flex",
    alignItems: "center"
  },
  starLogo: {
    height: "40px",
    margin: "0px 16px"
  },
  shuXian: {
    color: "#DFE0E2"
  },
  system: {
    fontSize: "14px",
    marginLeft: "16px"
  },
  headerRight: {
    display: "flex",
    alignItems: "center"
  },
  user: {
    margin: "0px 16px"
  },
  selectCompany: {
    width: "80vw",
    height: "66vh",
    backgroundColor: "#F6F7FA",
    borderRadius: token.borderRadius
  },
  selectCompanyList: {
    margin: "24px"
  },
  companyCard: {
    display: "flex",
    alignItems: "center",
    borderRadius: token.borderRadius
  },
  companyContent: {
    marginLeft: "16px"
  }
}));
var style_default = useStyles;
export {
  style_default as default
};
